'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/router';

import { useCurrentUser } from '~/domains/auth/queries';
import { useTrack } from '~/hooks/event';

interface Props {
  page: string;
  properties?: Record<string, unknown>;
}

export function TrackPage({ page, properties }: Props) {
  const { track } = useTrack();
  const { query } = useRouter();
  const { user } = useCurrentUser();

  useEffect(() => {
    if (!user) return;
    track(`viewed ${page} page`, {
      ...properties,
      ...query,
      query,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return null;
}
